//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'
import config from '@/config'
import { solicitatioAdd, solicitatioQuery } from '@/api/youzheng.js'
import { getAddressDefault, addAddress, editAddress, operateCreditlist } from '@/api/user'
import addressPicker from '@/views/components/address-picker2'
import { nowInDateBetwen } from '@/libs/utils'
import { getConfig, addFile } from '@/api/wx.js'
export default {
  components: {
    addressPicker
  },
  props: ['partyObj'],
  data () {
    return {
      baseUrl: config.baseUrl,
      photoObj: {
        // 上传图片
        imgcount: 4,
        imglist: [],
        fileUrlArr: []
      },
      title: '',
      partyid: this.$route.params.artid,
      Orientation: null,
      status: 0, // 0还未开始，1正在进行，-1结束
      addressValue: [],
      addressObj: {
        NAME: '',
        MOBILE: '',
        ADDRESS: '',
        PROVINCEID: '',
        CITYID: '',
        COUNTYID: '',
        ID: ''
      },
      defautAddress: false,
      flag: false,
      auditStatus: ''
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  watch: {
    addressValue: {
      handler: function (val) {
        this.addressObj.PROVINCEID = val[0]
        this.addressObj.CITYID = val[1]
        this.addressObj.COUNTYID = val[2]
      },
      deep: true
    }
  },
  mounted () {
    document.title = this.partyObj.title
    this.status = nowInDateBetwen(
      this.partyObj.collectstartdate,
      this.partyObj.collectenddate
    )
    this.wxconfig()
    this.query()
    this.getaddress()
  },
  methods: {
    getaddress () {
      getAddressDefault({
        accountid: this.accountid,
        userid: this.userid
      }).then(res => {
        if (res.status === 'suc') {
          if (res.returnValue !== '') {
            this.$set(
              this.addressValue,
              0,
              res.returnValue.PROVINCEID.toString()
            )
            this.$set(this.addressValue, 1, res.returnValue.CITYID.toString())
            this.$set(
              this.addressValue,
              2,
              res.returnValue.COUNTYID.toString()
            )
            this.defautAddress = true
            this.addressObj.NAME = res.returnValue.NAME
            this.addressObj.MOBILE = res.returnValue.MOBILE
            this.addressObj.ADDRESS = res.returnValue.ADDRESS
            this.addressObj.ID = res.returnValue.ID
          } else {
            this.addressValue.splice(0, this.addressValue.length)
            this.defautAddress = false
          }
          this.flag = true
        }
      })
    },
    onblur () {
      document.activeElement.scrollIntoViewIfNeeded(true)
    },
    query () {
      solicitatioQuery({
        openid: this.userid,
        partyid: this.partyid
      }).then(res => {
        if (res.success) {
          this.title = res.obj.worksname
          this.auditStatus = res.obj.auditStatus
          if (res.obj.pic !== '') {
            this.photoObj.imglist = []
            this.photoObj.fileUrlArr = []
            let arr = res.obj.pic.split(';')
            res.obj.picpath.forEach((el, index) => {
              this.photoObj.imglist.push({
                id: arr[index],
                filepath: el
              })
              this.photoObj.fileUrlArr.push(el)
            })
          }
          if (this.auditStatus === 2) {
            this.$vux.alert.show({
              content: `<div style="font-weight:bold;font-size:18px">审核不通过</div>` + `</br><div>理由：${res.obj.remark}</div>`
            })
          }
        }
      })
    },
    sumbit () {
      if (this.auditStatus === 1) {
        this.$vux.toast.text('审核通过，不能修改作品')
        return false
      } else {
        if (this.addressObj.NAME === '') {
          this.$vux.toast.text('请输入姓名')
          return false
        }
        if (this.addressObj.MOBILE === '') {
          this.$vux.toast.text('请输入电话')
          return false
        }
        if (this.addressValue.length < 1) {
          this.$vux.toast.text('请选择地区')
          return false
        }
        if (this.addressObj.ADDRESS === '') {
          this.$vux.toast.text('请输入详细地址')
          return false
        }
        if (this.title === '') {
          this.$vux.toast.text('请填写标题')
          return false
        }
        if (this.title.length > 20) {
          this.$vux.toast.text('标题字数要在20字范围内')
          return false
        }
        if (this.photoObj.imglist.length === 0) {
          this.$vux.toast.text('请上传图片')
          return false
        }
        let picids = this.photoObj.imglist.map(item => item.id)
        picids = picids.join(';')
        solicitatioAdd({
          openid: this.userid,
          remark: this.title,
          partyid: this.partyid,
          pic: picids
        }).then(res => {
          if (res.success) {
            this.$vux.toast.text('提交成功,请等待活动开始时间！')
            // 活动投稿获取积分
            //   operateCreditlist({
            //     accountid: this.accountid,
            //     rulecode: 'contribute',
            //     credit: 50,
            //     owner_type: config.owner_type,
            //     terminaltype: 2
            //   })
            if (!this.defautAddress) {
              addAddress({
                accountid: this.accountid,
                openid: this.userid,
                name: this.addressObj.NAME,
                mobile: this.addressObj.MOBILE,
                address: this.addressObj.ADDRESS,
                provinceid: this.addressObj.PROVINCEID,
                cityid: this.addressObj.CITYID,
                countyid: this.addressObj.COUNTYID,
                isdefault: 1
              }).then(data => { })
            } else {
              editAddress({
                addressid: this.addressObj.ID,
                accountid: this.accountid,
                openid: this.userid,
                name: this.addressObj.NAME,
                mobile: this.addressObj.MOBILE,
                address: this.addressObj.ADDRESS,
                provinceid: this.addressObj.PROVINCEID,
                cityid: this.addressObj.CITYID,
                countyid: this.addressObj.COUNTYID,
                isdefault: 1
              }).then(data => { })
            }
            this.query()
          }
        })
      }
    },
    // 微信权限配置
    wxconfig () {
      let ua = window.navigator.userAgent.toLowerCase()
      // alert('ua:' + ua)
      let href = window.location.href.split('#')[0]
      if (
        ua.match(/MicroMessenger/i) == 'micromessenger' &&
        ua.match(/wxwork/i) == 'wxwork'
      ) {
        href = window.location.href.split('#')[0]
        // alert('企业微信客户端')
      } else if (ua.match(/micromessenger/i) == 'micromessenger') {
        href = this.$store.state.user.wechatSignUrl
        // alert('微信客户端')
      }
      getConfig({
        url: href
      }).then(re => {
        var configs = re.returnValue
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: configs.appId, // 必填，公众号的唯一标识
          timestamp: configs.timestamp, // 必填，生成签名的时间戳
          nonceStr: configs.nonceStr, // 必填，生成签名的随机串
          signature: configs.signature, // 必填，签名，见附录1
          jsApiList: ['chooseImage', 'uploadImage', 'previewImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      })
    },
    // 拍照或从手机相册中选图接口
    chooseFile (imglist, imgcount) {
      // alert("拍照接口")
      this.showmenu = false
      var _this = this
      wx.chooseImage({
        count: imgcount - imglist.length, // 默认5
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: res => {
          var localIds = res.localIds
          _this.index = 0
          if (localIds.length > 0) {
            _this.uploadFile(imglist, localIds)
          }
        }
      })
    },
    // 上传图片到微信
    uploadFile (imglist, localIds) {
      var _this = this
      if (_this.index >= localIds.length) {
        return
      }
      wx.uploadImage({
        localId: localIds[_this.index], // 需要上传的图片的本地ID，由chooseFile接口获得
        success: res => {
          addFile({
            mediaId: res.serverId
          }).then(re => {
            imglist.push(re.returnValue)
            _this.photoObj.fileUrlArr.push(re.returnValue.filepath)
            _this.index++
            _this.uploadFile(imglist, localIds)
          })
        }
      })
    },
    // 图片放大
    preview (index, fileList) {
      let arr = fileList.map(item => this.baseUrl + item)
      wx.previewImage({
        current: arr[index], // 当前显示图片的http链接
        urls: arr // 需要预览的图片http链接列表
      })
    },
    del (index) {
      this.photoObj.imglist.splice(index, 1)
    }
  }
}
